import { render, staticRenderFns } from "./RequestChange.vue?vue&type=template&id=162f66e2&scoped=true"
import script from "./RequestChange.vue?vue&type=script&lang=js"
export * from "./RequestChange.vue?vue&type=script&lang=js"
import style0 from "./RequestChange.vue?vue&type=style&index=0&id=162f66e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162f66e2",
  null
  
)

export default component.exports